import { useToast } from 'vue-toastification'

/**
 * Notificações globais do sistema (substituem o alert() do navegador).
 * Usa vue-toastification, já configurado em main.ts.
 */

export function notifySuccess(message: string) {
  useToast().success(message)
}

export function notifyError(message: string) {
  useToast().error(message)
}

export function notifyInfo(message: string) {
  useToast().info(message)
}

export function notifyWarning(message: string) {
  useToast().warning(message)
}
